function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'natural': 'rgb(242, 238, 232)','soft-pink': 'rgb(237, 225, 238)','faded-grey': 'rgb(129, 131, 135)','faded-brown': 'rgb(145, 129, 119)','faded-cream': 'rgb(242, 239, 228)','faded-black': 'rgb(76, 78, 82)','faded-navy': 'rgb(61, 86, 114)','bone': 'rgb(207, 203, 196)','coal': 'rgb(58, 62, 69)','eucalyptus': 'rgb(137, 139, 128)','pine-green': 'rgb(33, 56, 54)','smoke': 'rgb(183, 187, 192)','storm': 'rgb(161, 163, 165)','clay': 'rgb(117, 84, 73)','cypress': 'rgb(75, 83, 77)','white-heather': 'rgb(174, 176, 182)','ink-blue': 'rgb(56, 57, 68)','army': 'rgb(68, 76, 54)','mustard-yellow': 'rgb(141, 102, 42)','emerald': 'rgb(44, 59, 59)','athletic-grey': 'rgb(142, 146, 153)','denim': 'rgb(136, 151, 167)','charcoal-black': 'rgb(31, 33, 37)','burgundy-melange': 'rgb(65, 39, 40)','coal-black': 'rgb(58, 62, 69)','lime-bone': 'rgb(217, 223, 182)','charcoal-grey-heather': 'rgb(107, 107, 107)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
